const axios = require("axios")
const dayjs = require("dayjs")
const dayjsRecur = require("dayjs-recur")
const timezone = require('dayjs/plugin/timezone')
dayjs.extend(dayjsRecur)
dayjs.extend(timezone)

const vibes = require('vibemap-constants/dist/vibes')
const helpers = require('vibemap-constants/dist/helpers.js')
const { getCategory } = vibes

const getImage = (image, type = 'original', backup = 'imagekit_url') => {
  return typeof (image) == 'string'
    ? image
    : image[type]
      ? image[type]
      : image[backup]
}


const parseDateTime = (datetime) => {
  const date = datetime ? dayjs(datetime) : null
  return date
}


const formatDateTime = (
  datetime,
  formatHtml = false,
  showDayOfWeek = false,
  showTime = false
) => {
  if (datetime) {
    if (typeof (datetime) == 'string') datetime = parseDateTime(datetime)

    const month = datetime.format('MMM')
    const day = datetime.format('D')
    const weekday = datetime.format('ddd')
    const hour = datetime.format('h:mm A')

    const is_all_day = hour == '12:00 AM'

    // FIXME: Naively assume that midnight 12am is all_day
    const dateFormated = is_all_day || !showTime
      ? `${showDayOfWeek ? weekday : null} ${month} ${day}`
      : `${showDayOfWeek ? weekday : null} ${month} ${day} ${hour}`

    return dateFormated
  } else {
    return null
  }
}


const eventsToCards = (events) => {

  const cards = events.map(event => {
    //console.log('events to cards ', event)
    // FIXME: This is a hack to get the right date; shoudl be set on server
    const name = event?.properties?.name
    const start_date = event?.properties?.start_date
    // Elastic datetimes are currently in Central time
    const city = event?.properties?.city

    const should_offset = false
    const start_date_central = should_offset
      ? dayjs.tz(start_date, 'America/Chicago')
      : dayjs(start_date)

    const [start_date_naive] = start_date.split(/[-+]\d+:\d+$/);
    const startTime = formatDateTime(start_date_naive, false, true)
    const endTime = formatDateTime(event?.properties?.end_date, false, true)

    const place = event?.properties?.hotspots_place
    const placeName = place?.properties?.name ? place?.properties?.name : event?.properties?.hotspots_place

    let category = `${startTime} ${startTime && placeName ? ' • ' : ''} ${placeName ? placeName : 'event'}`
    let subcategory = null

    if (event.properties.categories && event.properties.categories.length > 0) {
      subcategory = event.properties.categories[0]
    }

    const hotspots_place = event?.properties?.hotspots_place
    const eventImages = event?.properties?.vibemap_images
    const placeImages = hotspots_place?.properties?.vibemap_images

    const vibemap_images = eventImages && eventImages.length > 0
      ? event.properties.vibemap_images.map(image => getImage(image))
      : placeImages
        ? placeImages.map(image => {image.original})
        : []

    const thumbnails = vibemap_images.map(image => {
      const thumbnail_url = image
      const widthConfig = "tr=w-480,fo-auto"
      const thumbnail_settings = thumbnail_url && thumbnail_url.includes("?") ? `&${widthConfig}` : `?${widthConfig}`
      const cache_buster = thumbnail_url && thumbnail_url.includes("?") ? `&${Date.now()}` : `?${Date.now()}`
      const thumbnail = thumbnail_url + thumbnail_settings + cache_buster
      return thumbnail
    })

    const vibes = event.properties?.vibes ? event.properties.vibes : []
    const vibesCombined = vibes.concat(event?.hotspots_place?.properties?.vibes
      ? event?.hotspots_place?.properties?.vibes
      : [])

    event.type = 'event'
    event.fieldGroupName = 'posts'
    event.placeId = event.id

    event.properties.address = event?.properties?.hotspots_place?.properties?.address

    const is_free = event.properties.price == 'free' || event.properties.tags.map(tag => tag.toLowerCase()).includes('free')

    event.cardState = {
      id: event.id,
      slug: event.properties.slug,
      eventId: event.id,
      title: event.properties.name,
      category: category,
      dateTime: start_date_naive,
      start_date: start_date_naive,
      end_date: event.properties.end_date,
      description: event.properties.description,
      //city: place.neighborhood,
      image: thumbnails,
      is_approved: event.properties.is_approved,
      is_featured: event.properties.is_featured,
      is_free: is_free,
      price: event.properties.price,
      thumbnails: thumbnails,
      subcategory: subcategory,
      card_type: 'event',
      url: event.properties.url,
      venue: event.properties.hotspots_place,
      vibes: vibesCombined
    }

    return event

  })

  return cards
}

const nextDateFromRecurring = (...[
  recurrence,
  day,
  which
]) => {
  const date = dayjs() // .startOf('month')
  const ordinals = ["first", "second", "third", "fourth", "fifth"]
  const whichDay = ordinals.indexOf(which)
  const weekOfMonth = whichDay > 0 ? whichDay : 0

  // TODO: Handle daily, quarterly, yearly
  // And pass this same util to the details page
  const recurRule = recurrence == `monthly` ?
    date.recur()
      .every(day).daysOfWeek() // By day name
      .every([weekOfMonth]).weeksOfMonthByDay() // By which week of the month
    :
    date.recur()
      .every(day).daysOfWeek() // Same day every week

  return recurRule
}

const graphToEvents = (edges = []) => {
  const events = edges.map(edge => {
    const groupEvent = edge.node
    const details = groupEvent.groupDetails

    const name = details.name
    const link = details.link
    const slug = groupEvent.slug
    const description = details.description
    // TODO: Handle multiple images
    const image = details?.image?.mediaItemUrl
    const images = [{
      url: image,
      original: image
    }]
    const location = details.map
    const price = details.price ?
      details.price :
      `free`

    const vibes = details.vibes ?
      details.vibes.map(vibe => vibe.slug) : []

    const recurring = details.recurring
    const recurrence = details.recurrence
    const which = details.which
    const day = details.day[1]

    const startTime = details.startTime ?
      details.startTime :
      `00:00`
    const endTime = details.startTime ?
      details.endTime :
      `00:00`

    const recurRule = nextDateFromRecurring(recurrence, day, which)

    const nextStartTime = dayjs(recurRule.next(1).toLocaleString()
      .replace(`00:00:00`, startTime))

    const nextEndTime = dayjs(recurRule.next(1).toLocaleString()
      .replace(`00:00:00`, endTime))

    const event = {
      id: slug,
      title: name,
      geometry: {
        type: "Point",
        coordinates: [-122.26747099999956, 37.81396520000001]
      },
      dateTime: nextStartTime,
      image: images,
      card_type: 'event',
      properties: {
        name: name,
        title: name,
        url: link,
        address: location?.streetAddress,
        categories: [],
        city: details.cities && details.cities[0].slug,
        description: description,
        is_online: false,
        images: [],
        hotspots_place: location,
        location: location,
        start_date: nextStartTime,
        end_date: nextEndTime,
        vibemap_images: images,
        likes: 10,
        price: price,
        recurs: true,
        vibes: vibes
      }
    }

    return event
  })

  return events
}

const graphEventsToCards = (edges) => {

  const cards = edges.map(edge => {
    const groupEvent = edge.node
    const details = groupEvent.groupDetails
    const slug = groupEvent.slug

    const recurring = details.recurring
    const recurrence = details.recurrence
    const which = details.which
    const day = details.day[1]

    const price = details.price ?
      details.price :
      `free`

    const vibes = details.vibes ?
      details.vibes.map(vibe => vibe.slug) :
      []

    const card = {
      id: slug,
      title: details?.name,
      city: details.cities && details.cities[0].slug,
      //dateTime: nextStartTime,
      image: [details?.image?.mediaItemUrl], // TODO: Handle multiple images
      recurs: true,
      card_type: 'event',
      vibes: vibes,
      price
    }

    return card

  })

  return cards
}

const getBestCategory = (place, include_tags = false, search_value = null) => {
  let category = 'place'
  // TODO: Move this logic to vibemap-constants and make sure it's using the right categories
  if (place?.properties?.categories && place.properties.categories.length > 0) {
    const cats = place.properties.categories
    let highestLevel = 0
    cats.forEach(cat => {
      const catDetails = getCategory(cat)
      const name = catDetails && catDetails?.name
      const level = catDetails && catDetails?.level

      if (level > highestLevel && name) {
        category = name
        highestLevel = level
      }
    })
  }

  // TODO: Move the fetching and parsing to a reusable method.
  if (place?.properties?.subcategory) {
    const categoryDetails = getCategory(subcategory)
    category = categoryDetails?.name
  }

  if (include_tags && place?.properties?.tags && place.properties.tags.length > 0) {
    const tags = place.properties.tags
    // 1st tag and pick random 2nd tag; bu  t not 1st tag again
    const random_secondary = tags.length > 1 && tags[1 + Math.floor(Math.random() * (tags.length - 1))];
    category = random_secondary ? tags[0] + ', ' + random_secondary : tags[0]
  }

  if (place?.properties?.short_description) {
    category = place.properties.short_description
  }

  return category
}


// Make a title card from the theme
const makeTitleCard = (placeCopy) => {
  // TODO: This should be done on the server
  const imageCopy = placeCopy?.properties?.vibemap_images?.[0]

  const featuredPlace = {
    ...placeCopy,
    "name": titleCard?.title,
    "id": titleCard?.id,
    "slug": titleCard?.slug,
    "description": titleCard?.description,
    "geometry": titleCard?.geometry,
    "subcategory": titleCard?.subtitle,
    "slug": "featured",
    "score": 1.0,
    "thumbnails": [titleCard.image],
    "properties": {
      ...placeCopy?.properties,
      "id": titleCard?.id,
      "slug": titleCard?.slug,
      "description": titleCard?.description,
      "note": titleCard?.description,
      "featured": true,
      "is_title_card": true,
      "score": 1.0,
      //"subcategory": titleCard?.subtitle,
      "vibes": titleCard?.vibes || [],
      "vibemap_images": [{
        ...imageCopy,
        "title": titleCard?.title,
        "caption": titleCard?.title,
        "original": titleCard.image,
        "thumbnail_url": titleCard.image,
      }],
      "name": titleCard?.title,
      "short_description": titleCard?.subtitle,
      "type": "featured",
    }
  }

  return featuredPlace
}


const placeToCard = (place, include_properties = false, include_tags = false) => {

  let category = 'place'
  let subcategory = getBestCategory(place, include_tags)

  const vibemap_images = place?.properties?.vibemap_images
    ? place.properties.vibemap_images.map((image) => image.original)
    : []

  const thumbnails = place?.properties?.vibemap_images
    ? place.properties.vibemap_images.map((image) => image.thumbnail_url)
    : [place?.properties?.thumbnail_url]

  const cardState = {
    id: place?.id?.trim(),
    placeId: place?.id?.trim(),
    title: place?.properties?.name,
    card_type: 'place',
    category: category,
    categories: place?.properties?.categories,
    description: place?.properties?.description,
    city: place?.neighborhood,
    image: vibemap_images,
    price: place?.properties?.price,
    subcategory: subcategory,
    slug: place?.properties?.slug,
    score: place?.properties?.average_score,
    stats: place?.properties?.stats,
    thumbnails: thumbnails,
    type: 'Feature',
    vibes: place?.properties?.vibes,
  }

  if (include_properties) {
    cardState.geometry = place.geometry
    cardState.properties = place.properties
  }

  return cardState
}

const placesToCards = (
  places,
  columnIndex = 0,
  include_properties = false,
  include_tags = false
) => {
  const cards = places
    ? places.map((place, index) => {
      let subcategory = getBestCategory(place, include_tags)

      place.index = helpers.encodeCardIndex(columnIndex, index)
      place.card_type = 'place'
      place.place_type = 'place'
      place.featured = place?.properties?.featured ? place.properties.featured : false
      place.fieldGroupName = 'posts'
      place.placeId = place.id
      place.type = 'Feature'
      place.category = subcategory
      place.cardState = placeToCard(place, include_properties, include_tags)

      return place
    })
    : []

  return cards
}

const placesByCategory = (places, category = 'food') => {
  const cards = places.filter(place => place.properties.categories.includes(category))
  return cards
}

// Create the card object for a place or post block
const createCardState = (blockCard, columnIndex, blockIndex = 0, include_properties = true) => {
  const cardState = {
    id: blockCard?.id,
  };

  let cardObj = blockCard
  if (blockCard.singCard) {
    cardObj = blockCard.singCard
  }

  blockCard.index = helpers.encodeCardIndex(blockIndex, columnIndex)
  blockCard.note = cardObj.note

  try {
    cardState['title'] = cardObj.title;
    cardState['subcategory'] = cardObj.subcategory;
    cardState['image'] = cardObj.image && cardObj.image.includes('[') ? JSON.parse(cardObj.image) : cardObj.image;
    cardState['category'] = cardObj.type;
    cardState['index'] = blockCard.index;
    cardState['vibes'] = cardObj.vibes ? JSON.parse(cardObj.vibes) : null;
    cardState['description'] = cardObj.description;
    cardState['note'] = cardObj.note;
    cardState['city'] = cardObj.city;
    cardObj.cardState = cardState;

    // Pass Wordpress image override to card attribute
    if (blockCard.singCard && blockCard.singCard.overrideImage && blockCard.singCard.placeCardImage) {
      cardState['placeCardImage'] = blockCard.singCard.placeCardImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src
    }

    if (include_properties && cardObj.properties) {
      cardState.geometry = place.geometry
      cardState.properties = place.properties
    }
  }
  catch (e) {
    console.log('Problem with card state: ', e)
  }

  return blockCard
}

const fetchPlacesDetails = async (id, type = 'place') => {
  const source = axios.CancelToken.source()
  let apiEndpoint
  let category = ""

  if (type == "event") {
    apiEndpoint = `https://api.vibemap.com/v0.3/events/`
    category = `Event`
  }

  if (type == "place") {
    apiEndpoint = `https://api.vibemap.com/v0.3/places/`
    category = `Place`
  }

  if (apiEndpoint) {
    const response = await axios.get(`${apiEndpoint}${id.trim()}`, {
      cancelToken: source.token,
    }).catch(function (error) {
      // handle error
      console.log('Axios error ', error.statusText)
      return null
    })

    return response
  }
}

const fetchPlacesQuery = async (block) => {

  let { categoryQuery, distanceQuery, geoQuery, vibeQuery } = block

  if (block.overrideQuery) {
    vibeQuery = block.overrideQuery.vibe
    console.log('Should override geoQuery? ', geoQuery, distanceQuery)
  }
  if (typeof vibeQuery === 'string') vibeQuery = vibeQuery.replace(/\s/g, '').split(",") // Cast comma-separated list to array

  let options = {
    category: categoryQuery,
    distance: distanceQuery,
    point: geoQuery.longitude + ',' + geoQuery.latitude,
    ordering: 'vibe',
    vibes: vibeQuery ? vibeQuery : [] // Avoid issue in score function
  }

  if (block.overrideQuery) console.log('block.overrideQuery ', block.overrideQuery)

  let response = await helpers.fetchPlacePicks(options)
    .catch(error => {
      console.error(error);
    })

  return response
  // Map Vibemap data to Sing Card
  // TODO: Make this a reusable function

  // TODO: then this happens in the return method
  //const cards = placesToCards(response.data)
  //const topCards = cards.slice(0, numberOfCards)
  //setCardsList(topCards)
}


exports["default"] = placesToCards
exports.eventsToCards = eventsToCards
exports.graphToEvents = graphToEvents
exports.graphEventsToCards = graphEventsToCards
exports.makeTitleCard = makeTitleCard
exports.placeToCard = placeToCard
exports.placesToCards = placesToCards
exports.placesByCategory = placesByCategory
exports.createCardState = createCardState
exports.fetchPlacesDetails = fetchPlacesDetails
exports.fetchPlacesQuery = fetchPlacesQuery
